import { render } from "./LockWithCircleIcon.svg?vue&type=template&id=255e2bac"
const script = {}
script.render = render

export default script